/**
 * Name of the single command shared by every symbol shortcut button.
 */
export const INSERT_SYMBOL_COMMAND = "insertSymbol";

/**
 * Symbols exposed as individual toolbar buttons (CDE-16014).
 *
 * `name` doubles as the toolbar item name, so it must be unique across the
 * whole editor configuration. Additional symbols (for example the math
 * characters carried over from legacy CDE) only need a new entry here — no new
 * plugin, command or UI code is required.
 */
export const DEFAULT_SYMBOLS = [
  {
    name: "leftDoubleQuote",
    character: "“",
    label: "Left double quotation mark",
  },
  {
    name: "rightDoubleQuote",
    character: "”",
    label: "Right double quotation mark",
  },
  {
    name: "leftSingleQuote",
    character: "‘",
    label: "Left single quotation mark",
  },
  {
    name: "rightSingleQuote",
    character: "’",
    label: "Right single quotation mark (apostrophe)",
  },
];
